export enum SelectionHint
{
    UseRealtimeAggregates
}
